/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { reactSelectStyle } from "Config/Config";
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";
import { fetchOptions } from "helper/Common/CommonHelper";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";

const SaveImmunizationPopup = ({
  afterPopupClose = () => {},
  selectedImmunizationId,
  setSelectedImmunizationId = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // States for all input fields
  const [vaccineName, setVaccineName] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [doseNumber, setDoseNumber] = useState("");
  const [dateAdministrated, setDateAdministrated] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [administratedBy, setAdministratedBy] = useState("");
  const [facility, setFacility] = useState(null);
  const [batchNumber, setBatchNumber] = useState("");
  const [nextDose, setNextDose] = useState(null);
  const [nextDoseDueDate, setNextDoseDueDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [sideEffects, setSideEffects] = useState("");
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);

  // Options for react-select fields
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [nextDoseOptions, setNextDoseOptions] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  // Async load options for assignee
  const loadAssineeOptions = async (inputValue) => {
    try {
      const options = await getMemberOptions(inputValue);
      return options;
    } catch (error) {
      return [];
    }
  };

  // Get immunization details
  const getImmunizationDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_IMMUNIZATION_BY_ID +
        `/${selectedImmunizationId}?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const immunizationData = response.data;

        setVaccineName(immunizationData.vaccinename);
        setManufacturer(immunizationData.manufacturer);
        setDoseNumber(immunizationData.dosenumber);
        setDateAdministrated(
          immunizationData.dateadministered
            ? new Date(immunizationData.dateadministered)
                .toISOString()
                .split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setAdministratedBy(immunizationData.administeredby);
        setFacility(
          immunizationData.facility
            ? {
                value: immunizationData.facility,
                label: immunizationData.facility,
              }
            : null
        );
        setBatchNumber(immunizationData.batchnumber);
        setNextDose(
          immunizationData.nextdoseduedate === ""
            ? { value: true, label: "Taken" }
            : { value: false, label: "Not Taken" }
        );
        setNextDoseDueDate(
          immunizationData.nextdoseduedate
            ? new Date(immunizationData.nextdoseduedate)
                .toISOString()
                .split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setSideEffects(immunizationData.sideeffects);
        setComments(immunizationData.comments);
        if (immunizationData.assignedtovalue) {
          setAssignTo({
            value: immunizationData.assignedtovalue,
            label: immunizationData.assignedtolabel,
          });
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Save immunization
  const saveImmunizationHandler = async () => {
    try {
      setIsSaving(true);
      const apiData = {
        vaccinename: vaccineName,
        manufacturer: manufacturer,
        dosenumber: doseNumber,
        dateadministered: new Date(dateAdministrated).toISOString(),
        administeredby: administratedBy,
        facility: facility?.value,
        batchnumber: batchNumber,
        nextdoseduedate:
          nextDose?.value === true
            ? ""
            : new Date(nextDoseDueDate).toISOString(),
        sideeffects: sideEffects,
        comments: comments,
        assignedto: assignTo ? assignTo.value : null,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (selectedImmunizationId) {
        requestUrl +=
          url.API_UPDATE_IMMUNIZATION +
          `/${selectedImmunizationId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_IMMUNIZATION + `?token=${token}`;
        response = await postData(requestUrl, apiData);
      }

      setIsSaving(false);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveImmunizationOffCanvas")
        ).hide();
        resetHandler();
        afterPopupClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Reset handler
  const resetHandler = () => {
    setVaccineName("");
    setManufacturer("");
    setDoseNumber("");
    setDateAdministrated(new Date().toISOString().split("T")[0]);
    setAdministratedBy("");
    setFacility(null);
    setBatchNumber("");
    setNextDose(null);
    setNextDoseDueDate("");
    setSideEffects("");
    setComments("");
    setAssignTo(null);
    setSelectedImmunizationId(null);
  };

  useEffect(() => {
    if (selectedImmunizationId) {
      getImmunizationDetails();
    }
  }, [selectedImmunizationId]);

  // Fetch facility and next dose options
  useEffect(() => {
    fetchOptions(
      `${url.SERVER_URL}${url.HOSPITALS_OPTIONS}`,
      setFacilityOptions
    );
    setNextDoseOptions([
      { value: true, label: "Taken" },
      { value: false, label: "Not Taken" },
    ]);
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveImmunizationOffCanvas"
      aria-labelledby="saveImmunizationOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary icon-md">
              vaccines
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Immunization
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update immunization details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">
                Vaccine Name <span className="text-danger fw-bold">*</span>
              </label>
              <input
                type="text"
                name="vaccineName"
                value={vaccineName}
                onChange={(e) => setVaccineName(e.target.value)}
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder="Enter Vaccine Name"
              />
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">
                Manufacturer <span className="text-danger fw-bold">*</span>
              </label>
              <input
                type="text"
                name="manufacturer"
                value={manufacturer}
                onChange={(e) => setManufacturer(e.target.value)}
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder="Enter Manufacturer"
              />
            </div>
            <div className="row">
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">
                  Dose Number <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="number"
                  name="doseNumber"
                  value={doseNumber}
                  onChange={(e) => setDoseNumber(e.target.value)}
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Dose Number"
                />
              </div>
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">
                  Date Administrated{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="date"
                  name="dateAdministrated"
                  value={dateAdministrated}
                  onChange={(e) => setDateAdministrated(e.target.value)}
                  className="form-control fs-sm shadow-none border border-gray-300"
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">
                  Administrated By{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="text"
                  name="administratedBy"
                  value={administratedBy}
                  onChange={(e) => setAdministratedBy(e.target.value)}
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Administrator"
                />
              </div>
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">
                  Batch Number <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="number"
                  name="batchNumber"
                  value={batchNumber}
                  onChange={(e) => setBatchNumber(e.target.value)}
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Batch Number"
                />
              </div>
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Facility</label>
              <Select
                isClearable
                name="facility"
                options={facilityOptions}
                placeholder="Select Facility"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={facility}
                onChange={setFacility}
              />
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">
                Next Dose <span className="text-danger fw-bold">*</span>
              </label>
              <Select
                isClearable
                name="nextDose"
                options={nextDoseOptions}
                placeholder="Select Next Dose"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={nextDose}
                onChange={setNextDose}
              />
            </div>
            <div
              className={
                nextDose?.value === false ? "form-group mb-4" : "d-none"
              }
            >
              <label className="d-block fw-semibold mb-2">
                Next Dose Due Date
              </label>
              <input
                type="date"
                name="nextDoseDueDate"
                value={nextDoseDueDate}
                onChange={(e) => setNextDoseDueDate(e.target.value)}
                className="form-control fs-sm shadow-none border border-gray-300"
              />
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Side Effects</label>
              <textarea
                name="sideEffects"
                id="sideEffects"
                rows="5"
                placeholder="Enter Side Effects"
                className="form-control fs-sm shadow-none border border-gray-300"
                value={sideEffects}
                onChange={(e) => setSideEffects(e.target.value)}
              ></textarea>
            </div>
            <div className="form-group mb-4">
              <label htmlFor="comments" className="d-block fw-semibold mb-2">
                Comments
              </label>
              <textarea
                name="comments"
                id="comments"
                rows="5"
                placeholder="Enter Comments"
                className="form-control fs-sm shadow-none border border-gray-300"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              ></textarea>
            </div>
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Assign To</label>
              <AsyncSelect
                isClearable
                name="assignTo"
                loadOptions={loadAssineeOptions}
                defaultOptions={false}
                cacheOptions={false}
                placeholder="Select Assignee"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={assignTo}
                onChange={setAssignTo}
              />
            </div>
            <div
              className={
                vaccineName &&
                manufacturer &&
                doseNumber &&
                dateAdministrated &&
                administratedBy &&
                batchNumber &&
                nextDose
                  ? "group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto"
                  : "d-none"
              }
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveImmunizationHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    Save Immunization
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveImmunizationPopup;
